/* eslint-disable no-console */
import React from 'react';
import ReactDOM from 'react-dom';

const Prismic = require('prismic-javascript');
const PrismicDOM = require('prismic-dom');

const {
  globalConfig: { prismicApi },
} = window;

const accessToken =
  'MC5ZUnd1VFJBQUFDRUE4OHNC.77-977-9H--_vTPvv73vv70lXUxl77-977-977-977-977-977-977-9a--_vU_vv70idu-_ve-_ve-_ve-_vU7vv73vv73vv70';

const initializeEmailSubscription = () => {
  import(/* webpackChunkName: "enews" */ '../../_shared/components/Enews').then((module) => {
    const Enews = module.default;
    ReactDOM.render(<Enews />, document.getElementById('gcc-enews'));
  });
};

const initializeFooterData = () => {
  try {
    Prismic.getApi(prismicApi, { accessToken })
      .then((api) => api.getByID('YRwbUxAAACIA82wd'))
      .then(({ data }) => {
        const { center_column: value } = data;
        document.querySelector('#bca-site-hours').innerHTML = PrismicDOM.RichText.asHtml(value)
          .replace(/<br \/>/g, ' ')
          .replace(/<p>/g, '')
          .replace(/<\/p>/g, '');
      });
  } catch (err) {
    console.log('Error fetching Prismic: ', err);
  }
};

export default function Footer() {
  initializeFooterData();
  initializeEmailSubscription();
}
